var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-flex"},[_c('span',{staticClass:"animate-bounce"},[_vm._v(".")]),_vm._v(" "),_c('span',{staticClass:"animate-bounce animation-delay-200"},[_vm._v(".")]),_vm._v(" "),_c('span',{staticClass:"animate-bounce animation-delay-400"},[_vm._v(".")])])
}]

export { render, staticRenderFns }